
import { RouteObject, Navigate, useParams } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ProductsPage from '../pages/products/page';
import ProductDetailPage from '../pages/product-detail/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import ClinicalApplicationsPage from '../pages/clinical-applications/page';
import ForProvidersPage from '../pages/for-providers/page';
import ImplementationROIPage from '../pages/implementation-roi/page';
import CompliancePage from '../pages/compliance/page';
import ClinicalSciencePage from '../pages/clinical-science/page';
import NotFoundPage from '../pages/NotFound';

// Redirect component for backward compatibility
const ProductRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/products/${slug}`} replace />;
};

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/:slug',
    element: <ProductDetailPage />,
  },
  {
    path: '/product/:slug',
    element: <ProductRedirect />,
  },
  {
    path: '/clinical-applications',
    element: <ClinicalApplicationsPage />,
  },
  {
    path: '/for-providers',
    element: <ForProvidersPage />,
  },
  {
    path: '/implementation-roi',
    element: <ImplementationROIPage />,
  },
  {
    path: '/compliance',
    element: <CompliancePage />,
  },
  {
    path: '/clinical-science',
    element: <ClinicalSciencePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
